"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCurrentProfileCache = void 0;
var lodash_1 = require("lodash");
var toolbox_browser_fetch_1 = require("@zapier/toolbox-browser-fetch");
var utils_1 = require("../utils");
// Memoize this so that we don't fetch more than once
// (unless the baseUrl is different, which probably won't ever happen)
var getCurrentProfile = lodash_1.memoize(function (baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var url, cachedCurrentProfile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseUrl + "/api/v3/profiles";
                return [4 /*yield*/, toolbox_browser_fetch_1.getJson(url)];
            case 1:
                cachedCurrentProfile = _a.sent();
                return [2 /*return*/, cachedCurrentProfile];
        }
    });
}); });
// Only exposed for testing purposes
exports.clearCurrentProfileCache = function () {
    return getCurrentProfile.cache.clear && getCurrentProfile.cache.clear();
};
var createMaybeAddUserAndIdentityId = function (config) {
    return function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, identity_id, _a, baseUrl, cachedCurrentProfile, active_id, objects, e_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    // We don't want to be calling `/api/v3/profiles` from the server.
                    if (!utils_1.isBrowser()) {
                        return [2 /*return*/];
                    }
                    userId = (_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.userId;
                    identity_id = (_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.identity_id;
                    if (!(!userId || !identity_id)) return [3 /*break*/, 4];
                    _a = config.get(['service', 'baseUrl']).baseUrl, baseUrl = _a === void 0 ? '' : _a;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCurrentProfile(baseUrl)];
                case 2:
                    cachedCurrentProfile = _d.sent();
                    active_id = cachedCurrentProfile.active_id, objects = cachedCurrentProfile.objects;
                    if (!userId) {
                        userId = active_id;
                    }
                    if (!identity_id) {
                        identity_id = objects[0].identity;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    return [3 /*break*/, 4];
                case 4:
                    event.apply({
                        userId: userId,
                        identity_id: identity_id,
                    });
                    event._deprecatedSetProprtiesInRoot(['userId', 'identity_id']);
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.default = createMaybeAddUserAndIdentityId;
